export function createReportSearchParams(
  search: Record<string, string | string[] | null | undefined>,
  excluded: Set<string>,
) {
  const next = new URLSearchParams();
  for (const [key, value] of Object.entries(search)) {
    if (excluded.has(key) || value == null || value === "") continue;
    next.set(key, Array.isArray(value) ? JSON.stringify(value) : String(value));
  }
  return next;
}
